import React from 'react'

import { getOffsetsHandbook } from 'services/apiRequests'

import { useDispatch } from 'react-redux'
import { setDirectoryItems, setId, setVersionId } from 'store/directorySlice'

const useGetOffsets = (requestData: boolean | undefined) => {
  const dispatch = useDispatch()

  const tryToGetOffsets = async () => {
    await getOffsetsHandbook().then((res) => {
      dispatch(setId(res.data.id))
      dispatch(setVersionId(res.data.id))
      dispatch(
        setDirectoryItems(
          res.data.units.map((unit) => {
            return {
              ...unit,
              modified: false,
            }
          }),
        ),
      )
    })
  }

  React.useEffect(() => {
    tryToGetOffsets().then()
  }, [requestData])

  return
}

export default useGetOffsets
